export default "__VITE_ASSET__CPloEKcd__"